const baseUrls = {
  adsServerGatewayCampaignsApiBaseUrl: `${process.env.REACT_APP_ADS_SERVER_API_GATEWAY_BASE_URL}/adcampaign/api`,
  // eslint-disable-next-line max-len
  adsServerGatewayContentUploaderApiBaseUrl: `${process.env.REACT_APP_ADS_SERVER_API_GATEWAY_BASE_URL}/content-uploader/api`,
  adsServerGatewayInventoryApiBaseUrl: `${process.env.REACT_APP_ADS_SERVER_API_GATEWAY_BASE_URL}/inventory/api`,
  adsServerGatewayUsersApiBaseUrl: `${process.env.REACT_APP_ADS_SERVER_API_GATEWAY_BASE_URL}/users/api`,
};

const urls = {
  commonUrls: {
    getStaticData: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/generic/getstaticdata`,
    uploadContent: `${baseUrls.adsServerGatewayContentUploaderApiBaseUrl}/contentuploader`,
    searchProducts: `${baseUrls.adsServerGatewayInventoryApiBaseUrl}/v2/productshapes`,
  },
  generalUrls: {
    getCampaignsInsights: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/campaigns/insights`,
  },
  advertisersUrls: {
    getAdvertisersList: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/advertisers`,
    addAdvertiser: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/advertisers`,
    editAdvertiser: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/advertisers`,
  },
  campaignsUrls: {
    getCampaignsList: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/campaigns`,
    getCampaignInfo: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/campaigns`,
    addCampaign: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/campaigns`,
    editCampaign: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/campaigns`,
  },
  advertsUrls: {
    getAdvertsList: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/aditem`,
    addAdvert: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/aditem`,
    editAdvert: `${baseUrls.adsServerGatewayCampaignsApiBaseUrl}/aditem`,
  },
  accountManagementUrls: {
    getApiAuthToken: `${baseUrls.adsServerGatewayUsersApiBaseUrl}/logins/externallogin`,
  },
};

export default urls;
